<template>
  <VLayout :title="$t('my_addresses.my_addresses')"><p class="user-help">{{ $t('my_addresses.help') }}</p>
    <AddressList />
    <VButtonGroup />
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";
import AddressList from "@/components/AddressList";
import VButtonGroup from "@/components/VButtonGroup";

export default {
  components: {
    VLayout,
    AddressList,
    VButtonGroup,
  },
  fallbackI18n: {
    messages: {
      und: {
        my_addresses: {
          my_addresses: "My addresses",
          help:
            "Please, configure your billing information and shipping address. You can add additional addresses to receive or send the products where you need it.",
        },
      },
    },
  },
};
</script>
